import NoImageIcon from 'assets/icons/no-image.svg';
import styles from './no-image.module.scss';

const NoImage = ({ className }: NoImageProps) => {
	return (
		<div className={[styles.wrapper, className ?? ''].join(' ')}>
			<NoImageIcon className={styles.icon} />
		</div>
	);
};

interface NoImageProps {
	className?: string;
}

export default NoImage;
